/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import { routes } from "../router/Routes";

interface IProps {
    banners: string[];
}
const BannersSlider = ({ banners }: IProps) => {
    const navigate = useNavigate();

    const settings = {
        dots: false,
        arrows: false,
        infinite: false,
        autoplay: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1499,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                },
            },
        ],
    };
    return (
        <>
            <div className="banner-slider">
                <Slider {...settings}>
                    {banners?.map((banner, idx) => {
                        return (
                            <div
                                onClick={() => navigate(routes.pages.offers)}
                                className="banner-slider-item"
                                key={`banner${idx}`}
                            >
                                <img src={banner} alt="banner" />
                            </div>
                        );
                    })}
                </Slider>
            </div>
        </>
    );
};
export default BannersSlider;
